<template>
    <div class="account container">
        <div class="account-container" v-if="authenticatedUser">
            <b-card class="text-center">
                <b-media>
                    <div v-if="!imageResponseStatusOk && imageResponseMessage">
                        <b-alert show :variant="imageResponseStatusOk ? 'success':'danger'">{{imageResponseMessage}}</b-alert>
                    </div>
                    <div style="text-algin: center">
                        <div v-if="authenticatedUser.imageURI" class="user-image-wrapper">
                            <b-img :src="authenticatedUser.imageURI" style="height: 100%; width: 100%" alt="placeholder" />
                            <font-awesome-icon style="cursor: pointer; color: #e45649; position: absolute; top: -0.7em; right: -0.7em" :icon="imageDeleting ? 'circle-notch':'times-circle'" :spin="imageDeleting" v-b-tooltip.hover :title="langAccount.clickToDeleteImage[locale]" @click.stop="deleteImage"/>
                        </div>
                        <font-awesome-icon v-else-if="imageUploading" style="height: 48px" size="2x" icon="circle-notch" :spin="true"/>
                        <font-awesome-icon style="cursor: pointer" v-else size="3x" icon="image" v-b-tooltip.hover :title="langAccount.clickToUploadAnImage[locale]" onclick="document.getElementById('image-uploader').click(); return false;"/>
                    </div>
                    <input type="file" id="image-uploader" style="visibility: hidden" ref="imageUploader" v-on:change="imageChange"/>
                    <h3 class="mt-0">{{authenticatedUser.name}} <small class="store-tag" v-if="authenticatedUser.role === 'store'">{{langAccount.store[locale]}}</small></h3>
                    <div class="card-text address">
                        <strong>{{authenticatedUser.address}}</strong><small> > </small>
                        <strong>{{authenticatedUser.city}}</strong><small> > </small>
                        <strong>{{authenticatedUser.province}}</strong><small> > </small>
                        <strong>{{authenticatedUser.country}}</strong>
                    </div>
                    <div class="card-text contact">
                        <span>{{authenticatedUser.email}}</span> <div class="text-center" style="width: 1rem; display: inline-block"> | </div> <span>{{authenticatedUser.phone}}</span>
                    </div>
                    <div class="card-text edit">
                        <router-link class="btn btn-outline-secondary" to="/profile">
                            {{langAccount.edit[locale]}} <font-awesome-icon icon="user-edit"/>
                        </router-link>
                    </div>
                </b-media>
            </b-card>
            <br />
            <b-card :title="langAccount.moreContacts[locale]" v-if="authenticatedUser.contacts.length > 0">
                <div class="card-text" v-for="(contact, i) in authenticatedUser.contacts" :key="i">
                    <strong>{{contact.name}}</strong> 
                    <div class="text-center" style="width: 1rem; display: inline-block"> | </div> 
                    <span class="language-tag" v-for="(l, n) in contact.languages" :key="n">{{l}}</span> 
                    <div class="text-center" style="width: 1rem; display: inline-block"> | </div>
                    <strong>{{contact.email}}</strong> <div class="text-center" style="width: 1rem; display: inline-block"> | </div> 
                    <strong>{{contact.phone}}</strong>
                </div>
            </b-card>
            <br />
            <b-card :title="langAccount.reviews[locale]">
                <br />
                <div class="review-container" v-if="authenticatedUser.reviews.length > 0">
                    <review v-for="(review, i) in authenticatedUser.reviews" :review="review" :key="i" v-show="i<1 || showAllReviews"/>
                    <div class="review-show-all text-center" v-if="authenticatedUser.reviews.length>1">
                        <b-button style="color: gray; text-decoration: none" variant="link" v-on:click.stop="showAllReviews = !showAllReviews">
                            <small style="margin-right: 1em;">{{showAllReviews ? 'Hide' : 'Show all'}}</small>
                            <font-awesome-icon class="show-all-icon" :icon="showAllReviews ? 'angle-double-up' : 'angle-double-down'"/>
                        </b-button>
                    </div>
                </div>
                <div class="review-none text-center" v-else>
                    <span class="text-muted">{{langAccount.noReview[locale]}}</span>
                </div>
            </b-card>
        </div>
        <div class="account-container text-center" v-else>
            <font-awesome-icon class="spinner" size="2x" icon="circle-notch" :spin="true"/>
        </div>
        <br />
        <b-card :title="langAccount.searchPosts[locale]">
            <div class="card-text">
                <quick-search :search="searchPost" :value="query" :loading="post.searchingCount || post.loadingPosts" :count="post.searchCount" :showStatus="true" :queryChanged="searchPostQueryChanged"/>
            </div>
            <div class="card-text" v-if="post.loadingPosts">
                <font-awesome-icon class="spinner" size="2x" icon="circle-notch" :spin="true"/>
            </div>
            <div class="card-text" v-else-if="!post.loadingPosts && post.items.length > 0">
                <post v-for="item in post.items" v-bind:key="item._id" :post="item" style="margin: 5px"/>
                <br />
                <br />
                <b-pagination align="center" size="md" :total-rows="post.total" v-model="currentPage" :per-page="post.itemsPerPage" @change="pageClicked">
                </b-pagination>
            </div>
            <div class="card-text" v-else>
                <b-alert show variant="danger" v-if="post.statusOk === false && post.errMessage">{{errMessage}}</b-alert>
                <strong class="no-result" v-else-if="post.statusOk">{{langAccount.noPostFound[locale]}}</strong>
            </div>
        </b-card>
        <br />
    </div>
</template>

<script>
/* eslint-disable */
import QuickSearch from '@/components/QuickSearch';
import vueSlider from 'vue-slider-component';
import NettipyoraButton from '@/components/NettipyoraButton';
import Review from '@/components/Review';
import Post from '@/components/Post';
import { mapState } from 'vuex';
import fileUploaderMixin from '@/mixins/fileUploaderMixin';
import langAccount from '@/store/lang/account';

export default {
    name: "account",
    mixins: [fileUploaderMixin],
    components: {
        NettipyoraButton,
        vueSlider,
        Review,
        QuickSearch,
        Post
    },
    computed: mapState({
        post: state => state.Account.post,
        imageUploading: state => state.Account.imageUploading,
        imageDeleting: state => state.Account.imageDeleting,
        imageResponseStatusOk: state => state.Account.imageResponseStatusOk,
        imageResponseMessage: state => state.Account.imageResponseMessage,
        authenticatedUser: state => state.authenticatedUser,
        locale: state => state.locale
    }),
    data() {
        return {
            langAccount,
            currentPage: 1,
            showAllReviews: false,
            query: {
                types: null,
                subTypes: null,
                status: null,
                provinces: null,
                cities: null,
                minPrice: undefined,
                maxPrice: undefined,
                condition:  null
            },
            file: null
        }
    },
    mounted() {
        this.searchPostQueryChanged({});
    },
    methods: {
        searchPost(query) {
            //get query
            this.query = query;
            query.page = this.currentPage;
            query.userID = this.$store.state.authenticatedUserID;
            this.$store.dispatch('ACCOUNT_FETCH_POSTS', query);
        },
        searchPostQueryChanged(query) {
            query.searchType = "count";
            query.userID = this.$store.state.authenticatedUserID;
            this.$store.dispatch('ACCOUNT_FETCH_COUNT', query)
        },
        pageClicked(newPageNum) {
            const query = JSON.parse(JSON.stringify(this.query));
            query.page = this.currentPage = newPageNum;
            this.$store.dispatch('ACCOUNT_FETCH_POSTS', query);
        },
        imageChange() {
            const self = this;
            const files = self.$refs.imageUploader.files;
            self.$store.commit('ACCOUNT_IMAGE_UPLOADING', true);
            self.singeFileUploader({file: files[0]}).then(uri => {
                self.$store.dispatch('ACCOUNT_UPLOAD_IMAGE', {imageURI: uri});
            }).catch(err => {
                console.log(err);
                self.$store.commit('ACCOUNT_IMAGE_UPLOADING', false);
                self.$store.commit('ACCOUNT_IMAGE_ERROR', "Error. Image couldn't upload");
            });
        },
        deleteImage() {
            this.$store.dispatch('ACCOUNT_DELETE_IMAGE');
        }
    }
}
</script>

<style scope lang="scss">
.account {
    .spinner {
        margin: 2em;
    }
    .account-container {
        margin-top: 1em;

        .user-image-wrapper {
            position: relative;
            width: 100px;
            height: 100px;
        }

        .address {
            font-size: 0.8em;
        }
        .contact {
            font-size: 0.9em;
        }
        .edit {
            .btn {
                font-size: .8em;
                padding: 0 5px 0 5px;
            }
        }
        .language-tag {
            padding-left: 5px;
            padding-right: 5px;
            background: gray;
            border-radius: 2px;
            color: white;
            margin: 2px;
        }
        .store-tag {
            padding-left: 5px;
            padding-right: 5px;
            margin-left: 5px;
            margin-right: 5px;
            background: gray;
            border-radius: 2px;
            color: white;
        }
        .review-none {
            border: 1px solid darkgray;
            padding: 0.5em;
            border-radius: 5px;
        }
    }
}
</style>
